import { QueryClient } from "@tanstack/react-query";

import { ReactQueryKeysAccount } from "services/queryKeys";

export const updateEngines = async ({
  queryClient,
}: {
  queryClient: QueryClient;
}): Promise<void> => {
  try {
    await queryClient.cancelQueries({
      queryKey: [ReactQueryKeysAccount.workspaceEngines],
    });
    await queryClient.invalidateQueries({
      queryKey: [ReactQueryKeysAccount.workspaceEngines],
    });
  } catch (e) {
    console.error("Failed to update engines from WS: ", e);
  }
};
